import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import "../Style/Sidebar.css";
import { LayoutDashboard, CloudUpload,  Bell, Users, FileText, FileDown, FileCheck, FileIcon, CarFront, FolderOpen, Megaphone, UserCheck, ShieldAlert,
  Briefcase, UserCog, Archive, QrCode, ChevronLeft, ChevronRight, LogOut, CreditCard, Receipt, AlertCircle, IndianRupee, Ticket, TicketCheck,
  TicketPercent, Wallet, Folder, DollarSign, History,   ClipboardList,
  BookOpen, Layers,  Star  , UserPlus , Database, Coins, ScrollText, Headset  , BadgeCheck, Send , Landmark, Shield ,
  Smartphone , CircleDollarSign, UploadCloud ,  
  icons} from "lucide-react";
import { FaCalendarAlt } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import { BASE_URL } from "../Apis/apiConfig";
import axios from "axios";
import logo from "../image/dashboard_ layout.png";
import SockJS from "sockjs-client";
import { Client } from "@stomp/stompjs";


const Sidebar = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [chatCount, setChatCount] = useState(0);
  const [loadingCount, setLoadingCount] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [openGroups, setOpenGroups] = useState({ 0: true });
  const [searchTerm, setSearchTerm] = useState("");

  const getUserChatCount = async () => {
    setLoadingCount(true);
    try {
      const token = localStorage.getItem("token");
      const societyName = localStorage.getItem("society");

      if (!token) {
        setChatCount(0);
        setLoadingCount(false);
        return;
      }

      const endpoint = `${BASE_URL}/chat/get-count-user-by-chat`;
      const response = await axios.post(endpoint, null, {
        params: { societyName },
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        timeout: 10000,
      });

      const resp = response.data;
      const count = typeof resp === "number" ? resp : (resp.count ?? resp);
      setChatCount(count);
    } catch (error) {
      console.error("Error fetching chat count:", error);
      setChatCount(0);
    } finally {
      setLoadingCount(false);
    }
  };

  const markAllRead = async () => {
    try {
      const token = localStorage.getItem("token");
      const societyName = localStorage.getItem("society");
      if (!token) return;
      const endpoint = `${BASE_URL}/chat/mark-all-read-by-society`;
      await axios.post(endpoint, null, {
        params: { societyName },
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (err) {
      console.warn("markAllRead failed:", err?.response?.data ?? err.message);
    }
  };

  useEffect(() => {
    getUserChatCount();
    const handleNewChatEvent = (ev) => {
      const onNotificationPage = location.pathname.startsWith("/notification");
      if (!onNotificationPage) {
        setChatCount((prev) => (prev ?? 0) + 1);
      }
    };

    window.addEventListener("new-chat", handleNewChatEvent);
    return () => {
      window.removeEventListener("new-chat", handleNewChatEvent);
    };
  }, [location.pathname]);

  const openNotifications = async () => {
    setChatCount(0);
    await markAllRead();
    handleNavigation("/notification");
  };

  const handleNavigation = (path) => {
    navigate(path);
    if (onClose && window.innerWidth < 768) onClose();
  };

useEffect(() => {
  const socket = new SockJS(`${BASE_URL}/ws-chat`);

  const client = new Client({
    webSocketFactory: () => socket, 
    reconnectDelay: 5000,

    onConnect: () => {
      console.log("STOMP connected");

      client.subscribe("/topic/chat", (message) => {
        const data = JSON.parse(message.body);

        setNotifications((prev) => [data, ...prev]);
        setToastMessage(data.message);
        setShowToast(true);

        setTimeout(() => setShowToast(false), 3000);
      });
    },

    onStompError: (frame) => {
      console.error("STOMP error:", frame.headers["message"]);
    },
  });

  client.activate();

  return () => client.deactivate();
}, []);

  const toggleGroup = (index) => {
  setOpenGroups((prev) => ({
    ...prev,
    [index]: !prev[index],
  }));
};
useEffect(() => {
  const activeGroupIndex = menuGroups.findIndex((group) =>
    group.items.some((item) => item.path === location.pathname)
  );

  if (activeGroupIndex !== -1) {
    setOpenGroups((prev) => ({
      ...prev,
      [activeGroupIndex]: true,
    }));
  }
}, [location.pathname]);

  const isActive = (path) => location.pathname === path;

  const menuGroups = [
    {
      title: "DASHBOARD & Support",
      items: [
        { label: "Dashboard", path: "/dashboard", icon: LayoutDashboard },
        { label: "Help and Support", path: "/help-support", icon: Headset  }
      ],
    },
    {
      title: "UPLOADS AND NOC",
      items: [
        { label: "Upload", path: "/upload-menu", icon: CloudUpload },
        { label: "NOC",  path: "/notification",  action: openNotifications,  icon: Bell, badge: notificationCount > 0 ? notificationCount : null,},
        {label: "Documents", icon: Folder,   path: "/documents", badgeColor: "red", },
        { label: "Circular Notice", path: "/circular-Notice", icon: Megaphone },
        {
          label: "Complaints Registered",
          path: "/complaints",
          icon: AlertCircle,
        },
      ],
    },

    {
      title: "Member Records",
      items: [
        { label: "Members", path: "/memeber-list", icon: Users },
        { label: "Bills", path: "/bill-society", icon: FileIcon },
        { label: "Receipts", path: "/receipt", icon: FileCheck },
        { label: "Credit Note List", path: "/credit-note", icon: FileText },
        {label: "Debit Note List", path: "/debit-note-society-name", icon: FileDown},
        { label: "Parking List", path: "/parking-list", icon: CarFront },
        { label: "Opening List", path: "/opening", icon: FolderOpen },
        { label: "Charges", path: "/add-charges", icon: IndianRupee },
        { label: "Vouchers", path: "/vouchers", icon: Ticket },
        { label: "Advance payment", path: "/advance-payment", icon: Wallet },
        { label: "Currently Year Ledger", path: "/currently-year-ledger", icon: FaCalendarAlt  },
        { label: "Ledger Edit ", path: "/ledger-edit", icon: Smartphone  }
      ],
    },
    {
      title: "Society Visitors",
      items: [{ label: "Visitor", path: "/visitor", icon: UserPlus },
        { label: "Rules", path: "/rules", icon: Shield  },
         { label: "Video Upload", path: "/welcome-uplaod", icon: UploadCloud   }
      ],
      
    },
    {
      title: "Role Plays And Guideline",
      items: [
        { label: "Assign Role", path: "/assign-role", icon: UserCheck },
        { label: "Role Management", path: "/role-management", icon: UserCog },
        { label: "Guide Line", path: "/guide-line", icon: BookOpen  },
      ],
    },

    {
      title: "Services",
      items: [
        {label: "Service Provider",  path: "/service-provider", icon: Briefcase},
        { label: "Emergency", path: "/emergency", icon: ShieldAlert },
        { label: "Rating", path: "/employee-rating", icon: Star },  
      ],
    },

    {
      title: "Bank Details",
      items: [{ label: "Bank Details", path: "/bank-details", icon: Wallet },
        { label: "Member Request", path: "/member-request", icon: Send  },
       { label: "Transaction", path: "/transaction", icon: Smartphone  }
      ],
       
    },
    {
      title: "REPORTS & TOOLS",
      items: [
        { label: "Report", path: "/report", icon: FileText },
        { label: "QR Scanner", path: "/qr-page", icon: QrCode },
      ],
    },
 {
    title: "History",
    items: [
      { label: "Deleted Data", path: "/deleted-member-history", icon: History },
      { label: "Archive Data", path: "/archive", icon: Archive }
    ]
  },
  {
    title: "Previous",
    items: [
      { label: "Previous Bills", path: "/previous-year-bills", icon: ClipboardList },
      { label: "Previous Receipts", path: "/previous-year-reciept", icon: BookOpen },
      { label: "Previous Credit Notes", path: "/previous-year-credit-notes", icon: CircleDollarSign },
      { label: "Previous Debit Notes", path: "/previous-year-debit-notes", icon: ScrollText },
      { label: "Previous Opening Balances", path: "/previous-year-opening", icon: Landmark },
      { label: "Previous Advance Payments", path: "/previous-year-advance-payment", icon: Layers }
    ]
  },
  // {
  //   title: "Finance Management ",
  //   items: [
  //     { label: "Add Interest", path: "/add-interest", icon: ClipboardList },
  //     { label: "Bill Master", path: "/bill-master", icon: FileText },
  //     { label: "Upload Master", path: "/upload-master", icon: UploadCloud },
  //     { label: "Member Interest charges", path: "/member-interest-charges", icon: Coins },
  //     { label: "Receipt Master", path: "/master-receipt", icon: Receipt  },
  //     { label: "Bluk Bill Generete ", path: "/society-batch-bills", icon: Layers   },
  //     { label: "Master Ledger", path: "/master-ledger", icon: BookOpen   },
  //     { label: "Master old Bill", path: "/old-master-data", icon: BookOpen   },
  //     { label: "Pending Bill", path: "/pending-bill-member", icon: BookOpen   },
  //   ]
  // }
  ];

  const filteredMenuGroups = menuGroups
  .map((group) => ({
    ...group,
    items: group.items.filter((item) =>
      item.label.toLowerCase().includes(searchTerm.toLowerCase())
    ),
  }))
  .filter((group) => group.items.length > 0);

  const sidebarContentRef = useRef(null);

  useLayoutEffect(() => {
    const savedScroll = sessionStorage.getItem("sidebarScrollPos");
    if (sidebarContentRef.current && savedScroll) {
      sidebarContentRef.current.scrollTop = parseInt(savedScroll, 10);
    }
  }, []);

  const handleScroll = () => {
    if (sidebarContentRef.current) {
      sessionStorage.setItem(
        "sidebarScrollPos",
        sidebarContentRef.current.scrollTop,
      );
    }
  };

  useEffect(() => {
  const activeGroupIndex = menuGroups.findIndex((group) =>
    group.items.some((item) => item.path === location.pathname)
  );

  if (activeGroupIndex !== -1) {
    setOpenGroups((prev) => ({
      ...prev,
      [activeGroupIndex]: true,
    }));
  }
}, [location.pathname]);

  return (
    <>
      <div
        className={`sidebar-overlay ${isOpen ? "open" : ""}`}
        onClick={onClose}
      ></div>
      <div  className={`modern-sidebar ${isOpen ? "open" : ""} ${
          isCollapsed ? "collapsed" : ""
        }`} >
        <div className="sidebar-header">
        {!isCollapsed && (
        <span className="sidebar-title" style={{ color: "#007BFF" }}>
          Menu
        </span>
)}
          <button
            className="collapse-toggle"
            onClick={() => setIsCollapsed(!isCollapsed)}
            title={isCollapsed ? "Expand" : "Collapse"}
          >
            {isCollapsed ? (
              <ChevronRight size={20} />
            ) : (
              <ChevronLeft size={20} />
            )}
          </button>
        </div>
        {!isCollapsed && (
  <div className="sidebar-search">
    <input
      type="text"
      placeholder="Search menu..."
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      className="sidebar-search-input"
    />
  </div>
)}
        <div
          className="sidebar-content"
          ref={sidebarContentRef}
          onScroll={handleScroll}
        >
        {/* {menuGroups.map((group, index) => ( */}
        {filteredMenuGroups.map((group, index) => (
  <div key={index} className="menu-group">

    {/* ✅ CLICKABLE TITLE */}
    {!isCollapsed && (
      <div
        className="group-header clickable"
        onClick={() => toggleGroup(index)}
      >
       <span style={{ color: "#2563eb", fontWeight: "600" }}>
         {group.title}
        </span>
        <span className="arrow text-blue-600">
        {openGroups[index] ? "▾" : "▸"}
       </span>
      </div>
    )}

    {/* ✅ SHOW ITEMS ONLY IF OPEN */}
  {(searchTerm.trim() !== "" || openGroups[index]) &&
      group.items.map((item, idx) => {
        const Icon = item.icon;
        const active = item.path ? isActive(item.path) : false;

        return (
          <button
            key={idx}
            className={`menu-item ${active ? "active" : ""}`}
             style={{
             color: active ? "#007BFF" : "",
             fontWeight: active ? "600" : "",
            }}
            onClick={() =>
              item.action ? item.action() : handleNavigation(item.path)
            }
            title={isCollapsed ? item.label : ""}
          >
            <div className="icon-container">
              <Icon size={20} />
            </div>

            {!isCollapsed && (
              <span className="menu-label">{item.label}</span>
            )}
          </button>
        );
      })}
  </div>
))}
        </div>

        <div className="sidebar-footer">
          <div className="footer-item">
            <span className="version-text">
              {!isCollapsed && (
                <span
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  <span style={{ fontSize: "14px", opacity: 0.8 }}>
                    Powered by
                  </span>
                  <img
                    src="https://www.zapsolutionz.com/ZAP%20WMS%20R.png"
                    alt="ZAP Solutionz Logo"
                    style={{ height: "22px", objectFit: "contain" }}
                  />
                </span>
              )}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
